export const getPlaceholderPhoto = (name: string = 'placeholder.jpg') => `${process.env.REACT_APP_ASSETS_URL}/tv-app/${name}`;